// @flow

export const ACTIONS = {
    FEATURES_SET: 'features-set',
    RESET_ALL: 'reset-all'
};
